import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, isRef as _isRef } from "vue"

const _hoisted_1 = { style: {"color":"#f56c6c"} }
const _hoisted_2 = { style: {"color":"#f56c6c"} }
const _hoisted_3 = { style: {"color":"#f56c6c"} }

import { ref, computed, watch, Ref } from 'vue'
import useI18nTl from '@/hooks/useI18nTl'
import SelectOperator from '@/components/SelectOperator.vue'
import { upsertProfitsharingPayee } from '@/api/operation'
import { ElMessage, ElMessageBox } from 'element-plus'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import { dateFormat, dateFormatRFC3339 } from '@/common/tools'
import InputWithUnit from '@/components/InputWithUnit.vue'
import FormRulesFactory from '@/common/formRules'
import { isSuperadmin } from '@/store/tool'


import { defineComponent, nextTick } from 'vue'

const __default__ = defineComponent({
  name: 'PayeeUpsert',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
  isEdit: {
    type: Boolean,
  },
  info: {
    type: Object,
    default: () => ({}),
  },
},
  emits: ['update:modelValue', 'submit', 'submitted'],
  setup(__props, { expose, emit }) {

const props = __props

const activityFormRule = ref({
  ...FormRulesFactory.generateCustomRules(['operatorId', 'payeeType'], 'selectNone', 'selectNone'),
  ...FormRulesFactory.generateCustomRules(
    ['payeeName', 'bankCard', 'bankCode', 'bankCardName'],
    'inputEmpty',
    'inputInvalid',
  ),
})
const { payeeTypes, bankCardTypes } = useProtocolEnums()

const { t, tl } = useI18nTl('Operation')



let subsForm = ref()
const clearValidate = () => {
  console.log('clearValidate')
  nextTick(() => {
    let t = setTimeout(() => {
      clearTimeout(t)
      subsForm.value?.clearValidate()
    })
  })
}

const record = ref<Record<string, any>>({})
const showDialog = computed({
  get: () => props.modelValue,
  set: (val: boolean) => {
    emit('update:modelValue', val)
    if (!val) {
      subsForm.value?.clearValidate()
      record.value = { bankCardType: 0 }
    }
  },
})

const submit = async () => {
  await subsForm.value?.validate()

  if (record.value.tradeFeePercentage != '') {
    let fp = Number(record.value.tradeFeePercentage)
    if (fp < 0.45) {
      ElMessage.warning(tl(`tradeFeePercentageDesc`))
      return
    }

    record.value.tradeFeePercentage = (fp / 100).toFixed(4) // 保留 4 位小数
  }
  if (record.value.minWithdrawAmount != '') {
    record.value.minWithdrawAmount = Number(record.value.minWithdrawAmount)
    if (record.value.minWithdrawAmount < 2) {
      ElMessage.warning(tl(`minWithdrawAmountDesc`))
      return
    }
  }
  if (record.value.withdrawFee != '') {
    record.value.withdrawFee = Number(record.value.withdrawFee)
    if (record.value.withdrawFee < 1) {
      ElMessage.warning(tl(`withdrawFeeDesc`))
      return
    }
  }

  upsertProfitsharingPayee({ payee: record.value })
    .then((res: any) => {
      if (props.isEdit) {
        ElMessage.success(t(`Base.editSuccess`))
      } else {
        ElMessage.success(t(`Base.createSuccess`))
      }
      showDialog.value = false
      emit('submitted')
    })
    .catch((err: any) => {
      console.log(err)
    })
}

watch(
  () => props.modelValue,
  (val) => {
    if (props.isEdit) {
      record.value = JSON.parse(JSON.stringify(props.info))
      if (record.value.tradeFeePercentage > 0) {
        record.value.tradeFeePercentage = (record.value.tradeFeePercentage * 100).toFixed(2) // 保留 3 位小数
      }
      record.value.minWithdrawAmount = String(record.value.minWithdrawAmount)
      record.value.withdrawFee = String(record.value.withdrawFee)
    } else {
      record.value = { bankCardType: 0 }
    }
  },
  { immediate: true },
)
expose({
  clearValidate,
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _unref(showDialog),
    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_isRef(showDialog) ? (showDialog).value = $event : null)),
    width: "60%",
    class: "upsert-dialog",
    title: props.isEdit ? _unref(tl)('editPayee') : _unref(tl)('addPayee'),
    "z-index": 2000
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        onClick: _cache[15] || (_cache[15] = ($event: any) => (showDialog.value = false))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Base.cancel')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        disabled: !_ctx.$hasPermission('post'),
        onClick: submit
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.isEdit ? _ctx.$t('Base.saveChanges') : _ctx.$t('Base.add')), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        "label-position": "top",
        "require-asterisk-position": "right",
        model: record.value,
        "validate-on-rule-change": false,
        ref_key: "subsForm",
        ref: subsForm,
        rules: activityFormRule.value
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('payeeName'),
                    prop: "payeeName",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: record.value.payeeName,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((record.value.payeeName) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.operator'),
                    prop: "operatorId",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      (!props.isEdit)
                        ? (_openBlock(), _createBlock(SelectOperator, {
                            key: 0,
                            modelValue: record.value.operatorId,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((record.value.operatorId) = $event))
                          }, null, 8, ["modelValue"]))
                        : (_openBlock(), _createBlock(_component_el_input, {
                            key: 1,
                            modelValue: record.value.operatorName,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((record.value.operatorName) = $event)),
                            disabled: true
                          }, null, 8, ["modelValue"]))
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('payeeType'),
                    prop: "payeeType",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: record.value.payeeType,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((record.value.payeeType) = $event)),
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(payeeTypes), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.label,
                              value: item.value,
                              key: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('bankCardType'),
                    prop: "bankCardType"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: record.value.bankCardType,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((record.value.bankCardType) = $event)),
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bankCardTypes), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.label,
                              value: item.value,
                              key: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('bankCardName'),
                    prop: "bankCardName",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: record.value.bankCardName,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((record.value.bankCardName) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('bankCard'),
                    prop: "bankCard",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: record.value.bankCard,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((record.value.bankCard) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('bankCode'),
                    prop: "bankCode",
                    required: ""
                  }, {
                    label: _withCtx(() => [
                      _createElementVNode("label", null, _toDisplayString(_unref(tl)('bankCode')), 1),
                      _createVNode(_component_el_link, {
                        type: "primary",
                        href: "https://open.yeepay.com/attachments/access?fileId=SWRhXc0brM",
                        target: "_blank"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("（" + _toDisplayString(_unref(t)('Base.refer')) + "）", 1)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("label", null, _toDisplayString(_unref(tl)('bankCodeEG')), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: record.value.bankCode,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((record.value.bankCode) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('uniteBankId'),
                    prop: "uniteBankId"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: record.value.uniteBankId,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((record.value.uniteBankId) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('bankCardMobile'),
                    prop: "contactsMobile"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: record.value.contactsMobile,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((record.value.contactsMobile) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              (_unref(isSuperadmin)())
                ? (_openBlock(), _createBlock(_component_el_col, {
                    key: 0,
                    span: 12
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: _unref(tl)('tradeFeePercentage'),
                        prop: "tradeFeePercentage"
                      }, {
                        label: _withCtx(() => [
                          _createElementVNode("label", null, _toDisplayString(_unref(tl)('tradeFeePercentage')), 1),
                          _createElementVNode("label", _hoisted_1, "（ " + _toDisplayString(_unref(tl)('tradeFeePercentageDesc')) + " ）", 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(InputWithUnit, {
                            modelValue: record.value.tradeFeePercentage,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((record.value.tradeFeePercentage) = $event)),
                            numberPlaceholder: "0.6",
                            units: [{ label: '%', value: '' }]
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_unref(isSuperadmin)())
                ? (_openBlock(), _createBlock(_component_el_col, {
                    key: 1,
                    span: 12
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: _unref(tl)('withdrawFee'),
                        prop: "withdrawFee"
                      }, {
                        label: _withCtx(() => [
                          _createElementVNode("label", null, _toDisplayString(_unref(tl)('withdrawFee')), 1),
                          _createElementVNode("label", _hoisted_2, "（ " + _toDisplayString(_unref(tl)('withdrawFeeDesc')) + " ）", 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(InputWithUnit, {
                            modelValue: record.value.withdrawFee,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((record.value.withdrawFee) = $event)),
                            numberPlaceholder: "2",
                            disabledUnit: true,
                            units: [{ label: '', value: '' }]
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_unref(isSuperadmin)())
                ? (_openBlock(), _createBlock(_component_el_col, {
                    key: 2,
                    span: 12
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: _unref(tl)('minWithdrawAmount'),
                        prop: "minWithdrawAmount"
                      }, {
                        label: _withCtx(() => [
                          _createElementVNode("label", null, _toDisplayString(_unref(tl)('minWithdrawAmount')), 1),
                          _createElementVNode("label", _hoisted_3, "（ " + _toDisplayString(_unref(tl)('minWithdrawAmountDesc')) + " ）", 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(InputWithUnit, {
                            modelValue: record.value.minWithdrawAmount,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((record.value.minWithdrawAmount) = $event)),
                            numberPlaceholder: "10",
                            disabledUnit: true,
                            units: [{ label: '', value: '' }]
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_unref(isSuperadmin)())
                ? (_openBlock(), _createBlock(_component_el_col, {
                    key: 3,
                    span: 12
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: _unref(tl)('isVisibleToAdminOnly'),
                        prop: "isVisibleToAdminOnly"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_switch, {
                            modelValue: record.value.isVisibleToAdminOnly,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((record.value.isVisibleToAdminOnly) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_unref(isSuperadmin)())
                ? (_openBlock(), _createBlock(_component_el_col, {
                    key: 4,
                    span: 12
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: _unref(tl)('isAdminProfit'),
                        prop: "isAdminProfit"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_switch, {
                            modelValue: record.value.isAdminProfit,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((record.value.isAdminProfit) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})